/** Convert Eastern Arabic / Persian digits to ASCII 0-9. */
export function westernDigits(value: string): string {
  return value
    .replace(/[\u0660-\u0669]/g, ch => String(ch.charCodeAt(0) - 0x0660))
    .replace(/[\u06F0-\u06F9]/g, ch => String(ch.charCodeAt(0) - 0x06F0));
}

export function formatEnNumber(n: number, opts?: Intl.NumberFormatOptions): string {
  return westernDigits(n.toLocaleString('en-US', opts));
}
